import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';

interface DetailSection7Props {
  submission: CreditSubmission;
}

export default function DetailSection7({ submission }: DetailSection7Props) {
  if (!submission.relations || submission.relations.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>7. Relasi Debitur</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {submission.relations.map((relation: any, index: number) => (
            <div key={index} className="border rounded-lg p-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="text-sm text-gray-600">Nama</label>
                  <p className="font-medium mt-1">{relation.name || '-'}</p>
                </div>
                <div>
                  <label className="text-sm text-gray-600">Hubungan</label>
                  <p className="font-medium mt-1">{relation.relationship || '-'}</p>
                </div>
                <div>
                  <label className="text-sm text-gray-600">No. Telepon</label>
                  <p className="font-medium mt-1">{relation.phone || '-'}</p>
                </div>
                <div>
                  <label className="text-sm text-gray-600">Alamat</label>
                  <p className="mt-1">{relation.address || '-'}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
